export const newSystemReducer = (state = [], action) => {
  // console.log(
  //   action.payload,
  //   "is payload of system",
  //   state,
  //   "is state of system"
  // );
  switch (action.type) {
    case "NEWSYSTEM":
      // console.log(state , "is state");
      if (state.length > 0) {
        // console.log(state , "is condition");
        state.push(action.payload);
      } else {
        // console.log(state , "is else");
        state.push(action.payload);
      }

      return state;

    //USER FORM ACTIONS START

    case "RESETSYSTEM":
      
      state = state.filter((item) => item.serial_number !== action.payload);
      // console.log("specify state is :", state);
      return state;

    default:
      return state;
  }
};
